<template>
  <div class="SX">
    <div class="container">
      <div class="title-tab">
        <span>当前位置：</span>
        <span @click="GoPartyDiscipline">党纪法规></span>
        <span @click="GoFenLei">分类系统></span>
        <span class="red">正文</span>
      </div>
      <!-- 正文 -->
      <div class="zhengwen">
        <h1>中国共产党国有企业基层组织工作条例（试行）</h1>
        <div class="first">
          <p>近日，中共中央印发了《中国共产党国有企业基层组织工作条例（试行）》（以下简称《条例》），并发出通知，要求各地区各部门认真遵照执行。</p>
          <p>中国共产党国有企业基层组织工作条例（试行）</p>
          <p>（2019年11月29日中共中央政治局会议审议批准 2019年12月30日中共中央发布）</p>
        </div>
 <div class="date">
         发布时间：2020-5-20&nbsp13:30
       </div>
        <div class="xh"></div>
        <div class="second">
          <p>第一章 总则</p>
          <p>第一条 为了深入贯彻习近平新时代中国特色社会主义思想，贯彻落实新时代党的建设总要求和新时代党的组织路线，坚持和加强党对国有企业的全面领导，提高国有企业党的建设质量，推动国有企业高质量发展，根据《中国共产党章程》和有关法律，制定本条例。</p>

          <p>第二条 国有企业党组织必须高举中国特色社会主义伟大旗帜，以马克思列宁主义、毛泽东思想、邓小平理论、“三个代表”重要思想、科学发展观、习近平新时代中国特色社会主义思想为指导，坚持党的基本理论、基本路线、基本方略，增强“四个意识”、坚定“四个自信”、做到“两个维护”，坚持和加强党的全面领导，坚持党要管党、全面从严治党，突出政治功能，提升组织力，强化使命意识和责任担当，推动国有企业深化改革，完善中国特色现代企业制度，增强国有经济竞争力、创新力、控制力、影响力、抗风险能力，为做强做优做大国有资本提供坚强政治和组织保证。</p>

          <p>一九八O年，党的十一届五中全会深刻总结历史经验特别是“文化大革命”的教训，制定了《关于党内政治生活的若干准则》，为拨乱反正、恢复和健全党内政治生活、推进党的建设发挥了重要作用，其主要原则和规定今天依然适用，要继续坚持。</p>

          <p>第三条 国有企业党组织工作应当遵循以下原则：</p>
          <p>（一）坚持加强党的领导和完善公司治理相统一，把党的领导融入公司治理各环节；</p>
          <p>（二）坚持党建工作与生产经营深度融合，以企业改革发展成果检验党组织工作成效；</p>
          <p>（三）坚持党管干部、党管人才，培养高素质专业化企业领导人员队伍和人才队伍；</p>
          <p>（四）坚持抓基层打基础，突出党支部建设，增强基层党组织生机活力；</p>
          <p>（五）坚持全心全意依靠工人阶级，体现企业职工群众主人翁地位，巩固党执政的阶级基础。</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    GoPartyDiscipline() {
      this.$router.push("/PartyDiscipline");
    },
    GoFenLei() {
      this.$router.push("/PartyDiscipline/FenLei");
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  width: 1200px;
  margin: 0 auto;
}
.title-tab {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 54px;
  cursor: pointer;
}
.red {
  color: red;
}
.zhengwen {
  width: 1200px;
  background-color: white;
  padding: 60px;
  box-sizing: border-box;
}
p {
  text-indent: 2em;
  font-size: 16px;
  color: #333333;
  margin-top: 20px;
}

h1 {
  text-align: center;
  font-size: 28px;
  color: #333333;
}
.first {
  text-align: center;
  font-size: 16px;
  color: #999999;
  margin-top: 28px;
  margin-bottom: 30px;
}
.daohang {
  margin: 20px 0;
}
.first p {
  font-weight: 600;
}
.date{
  color: #999999;
  font-size: 16px;
  text-align: center;
  margin-bottom: 28px;
}
</style>